module.exports = __webpack_public_path__ + "static/media/times-circle.6832fc6d.svg";